$(function () {
  if (!sessionStorage.isNewSession) {
    function setCookie(c_name, value, exdays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value =
        escape(value) +
        (exdays == null ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value;
    }

    function getCookie(c_name) {
      var c_value = document.cookie;
      var c_start = c_value.indexOf(" " + c_name + "=");
      if (c_start == -1) {
        c_start = c_value.indexOf(c_name + "=");
      }
      if (c_start == -1) {
        c_value = null;
      } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
      }
      return c_value;
    }

    const newsletter_popup = $('.newsletter-popup');
    const normal_popup = $('.popupTop');
    const cartPopup = document.querySelector(".cart-popup");
    const newsletterPopup = document.querySelector(".newsletter-popup");
    const recentViewPopup = document.querySelector(".modal-recently-viewed");

    function checkSession() {
      const is_recently_viewed = sessionStorage.getItem("recentlyViewedModal");
      const is_cart_abandoned = sessionStorage.getItem("cartModal");
      const cookieRecentView = getCookie("shopify_recently_viewed");
      
      jQuery.getJSON("/cart.js", function (response) {
        // get Json response
        const cart = response;
        const c = getCookie("visited");
        if (c !== "yes") {
          newsletterPopup.style.display = "block";
          setTimeout(function () {
            newsletterPopup.classList.add("show-popup");
          }, 5000);
        } else {
          if (
            cart.items.length >= 1 &&
            is_cart_abandoned !== "abandoned cart"
          ) {
            cartPopup.style.display = "block";
            setTimeout(function () {
              cartPopup.classList.add("show-popup");
            }, 5000);
            sessionStorage.setItem("cartModal", "abandoned cart");
          } else if (
            (cookieRecentView !== null && cookieRecentView !== '') &&
            is_recently_viewed !== "recently viewed" &&
            is_cart_abandoned !== "abandoned cart"
          ) {            
            recentViewPopup.style.display = "block";
            setTimeout(function () {
              recentViewPopup.classList.add("show-popup");
            }, 5000);
            sessionStorage.setItem("recentlyViewedModal", "recently viewed");
          }
        }
        setCookie("visited", "yes", 30);
      });
    }
    checkSession();

    // Close PopUps if click outside
    $(document).on('click', function (e) {
      if (!$(e.target).closest(".popupTop").length > 0) {
        normal_popup.removeClass('show-popup');
      }

      if (!$(e.target).closest(".newsletter-popup").length > 0) {
        newsletter_popup.removeClass('show-popup');
      }
    });

    // Newsletter PopUps Close Button event
    newsletter_popup.on('click', 'button.close', function () {
      newsletter_popup.removeClass('show-popup');
    });

    // Normal PopUps Close Button event
    normal_popup.on('click', 'button.close', function () {
      normal_popup.removeClass('show-popup');
    });

    sessionStorage.isNewSession = true;
  }
});
